module.exports = __webpack_public_path__ + "static/other/es-US.73daa13e.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/lingual/es-US.json
// module id = 1859
// module chunks = 0